import React from 'react'
import './Footer.scss'


function Footer() {
  return (
    <div className='footer'>
      <div className='footer_container'>

          <p>Copyright Baner Productions</p>
          <p>Latest Update 01/06/2026</p>
      </div>
    
    </div>
  )
}

export default Footer
